import * as Sentry from '@sentry/react';

interface SentryAuthUser {
  email?: string | null;
  name?: string | null;
}

export function syncSentryUser(user: SentryAuthUser | null): void {
  if (!user) {
    Sentry.setUser(null);
    return;
  }

  const email = user.email?.trim();
  if (!email) {
    Sentry.setUser(null);
    return;
  }

  const name = user.name?.trim();
  Sentry.setUser({
    email,
    ...(name ? { username: name } : {}),
  });
}
